/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.piesync.bridge.rpc.AppsRpc
 */
import * as References from './AppsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.piesync.bridge.rpc.AppsRpc#getAll
 */
export const GET_ALL_QUERY_FIELD_NAME = 'com_hubspot_piesync_bridge_rpc_AppsRpc_getAll';
export const GET_ALL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAllRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.piesync.bridge.rpc.AppsRpc#getApp
 */
export const GET_APP_QUERY_FIELD_NAME = 'com_hubspot_piesync_bridge_rpc_AppsRpc_getApp';
export const GET_APP_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APP_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getAppRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});